import { render } from "./ImproveScoreView.vue?vue&type=template&id=5fb11568"
import script from "./ImproveScoreView.vue?vue&type=script&lang=js"
export * from "./ImproveScoreView.vue?vue&type=script&lang=js"

import "./ImproveScoreView.vue?vue&type=style&index=0&id=5fb11568&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__